<template>
  <v-text-field
    outlined
    :label="label"
    prepend-inner-icon="mdi-clock-time-four-outline"
    placeholder="HH:MM"
    hide-details
    v-maska="'##:##'"
    :value="value"
    @input="
      $emit('input', $event)
      menu = false
    "
  />
</template>

<script>
import { maska } from "maska"

export default {
  directives: { maska },
  props: {
    value: { type: String, default: null },
    label: { type: String, default: null },
  },
  data: () => ({
    menu: false,
  }),
}
</script>
